//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { channelOrderListApi, channelOrderDetailApi } from '@/api/channel';
var STATUS = {
  0: '待发货',
  1: '仓库处理中',
  2: '已发货',
  3: '已取消'
};
export default {
  name: 'ChannelOrder',
  data: function data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: {
        page: 1,
        limit: 20,
        orderNo: '',
        outOrderNo: '',
        status: null
      },
      detailVisible: false,
      detail: null
    };
  },
  created: function created() {
    this.loadList(1);
  },
  methods: {
    loadList: function loadList(page) {
      var _this = this;
      if (page) this.query.page = page;
      this.loading = true;
      var params = {};
      Object.keys(this.query).forEach(function (key) {
        if (_this.query[key] !== '' && _this.query[key] !== null && _this.query[key] !== undefined) params[key] = _this.query[key];
      });
      channelOrderListApi(params).then(function (res) {
        _this.list = res && (res.list || res.records) || [];
        _this.total = Number(res && res.total || 0);
      }).finally(function () {
        _this.loading = false;
      });
    },
    changeSize: function changeSize(size) {
      this.query.limit = size;
      this.loadList(1);
    },
    reset: function reset() {
      this.query = {
        page: 1,
        limit: 20,
        orderNo: '',
        outOrderNo: '',
        status: null
      };
      this.loadList(1);
    },
    statusText: function statusText(value) {
      return STATUS[value] || '-';
    },
    statusType: function statusType(value) {
      return {
        0: 'warning',
        1: 'info',
        2: 'success',
        3: 'danger'
      }[value] || 'info';
    },
    address: function address(row) {
      return [row.province, row.city, row.district, row.detailAddress].filter(Boolean).join('') || '-';
    },
    showDetail: function showDetail(row) {
      var _this2 = this;
      channelOrderDetailApi(row.orderNo).then(function (res) {
        _this2.detail = res || row;
        _this2.detailVisible = true;
      });
    }
  }
};